import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { useConfigUI } from '../../context'
import { useDeleteSoil } from '../../hooks/soils'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
  /** The soil's name, so the confirmation names what it is about to remove. */
  name?: string
  onSuccess?: () => void
}

const DeleteSoilModal = ({
  id,
  interfaceId,
  name,
  onSuccess,
}: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const { mutate: deleteModal, isLoading: loadingDeleteSoil } = useDeleteSoil()

  const handleDeleteSite = () => {
    if (!id) return
    if (!interfaceId) return
    deleteModal(
      { interfaceId, id },
      {
        onSuccess: () => {
          onSuccess && onSuccess()
        },
      },
    )
  }

  return (
    <ConfirmDeleteModalUI
      title={t('DeleteSoil')}
      name={name}
      text={t('soilDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteSite}
      isLoading={loadingDeleteSoil}
    />
  )
}

export default DeleteSoilModal
